import React, { useState } from "react";
import {
  Button,
  Dialog as MUIDialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Checkbox,
} from "@mui/material";

import { TextFourteenBlack } from "../../../css components/Style";
import { ToggleOffOutlined, ToggleOnOutlined } from "@mui/icons-material";
import languageTranslator from "../../../../utils/languageTranslator";

export default function ConfirmPopUp({
  formikProps,
  dialogState,
  setDialogState,
}) {
  const [language, setLanguage] = useState("en");
  const handleClose = () => {
    setDialogState({ ...dialogState, state: false });
  };

  return (
    <React.Fragment>
      <MUIDialog open={dialogState.state} onClose={handleClose}>
        <DialogTitle style={{ paddingBottom: "0px" }}>
          <div style={{ display: "flex", justifyContent: "end" }}>
            <Typography>EN</Typography>
            <Checkbox
              style={{
                padding: "3px 9px",
                position: "relative",
                top: "-9px",
              }}
              onChange={(e) => {
                if (e.target.checked) {
                  setLanguage("id");
                } else {
                  setLanguage("en");
                }
              }}
              icon={<ToggleOffOutlined fontSize="large" />}
              checkedIcon={
                <ToggleOnOutlined fontSize="large" style={{ color: "red" }} />
              }
            />
            <Typography>ID</Typography>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <TextFourteenBlack>
              {languageTranslator(
                `Are you sure you want to ${dialogState?.data?.content}`,
                language
              )}
            </TextFourteenBlack>
          </DialogContentText>
        </DialogContent>

        <DialogActions style={{ padding: "0px 24px 16px" }}>
          <Button onClick={handleConfirm} variant="contained" autoFocus>
            Confirm
          </Button>

          <Button onClick={handleClose} variant="outlined" autoFocus>
            Cancel
          </Button>
        </DialogActions>
      </MUIDialog>
    </React.Fragment>
  );

  async function handleConfirm() {
    await dialogState?.data?.handleFunction();
    handleClose();
  }
}
